import { Component, OnInit, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { IAgentMonitor, EDBResponseType, IAgentStatusReason } from '../../../common/_all';
import { SocketService, EComando, EResponse, IComando } from '../../_services/socket.service';
import { AgenteService } from '../../_services/agente.service';
import { UsuarioService } from '../../_services/usuario.service';
import * as uuid from '../../_services/_objectID';
import * as moment from 'moment';
import { Subject } from 'rxjs/Subject';
@Component({
    selector: 'agent-op',
    template: `
        <div class="modal fade" tabindex="-1" role="dialog" id="agente-ops">
            <div class="modal-dialog modal-sm" role="document">
            <form novalidate #f="ngForm" >
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h5 class="modal-title">
                        <i class="fa fa-info-circle"></i> 
                        Agente {{agente?.idagente}} {{agente?.nombre}}</h5>
                  </div>
                  <div class="modal-body" style="font-size:13px">
                    <div class="panel panel-default" *ngIf="agente?.estado.indexOf('PAUSE') > -1">
                        <div class="panel-heading">
                            <div style="line-height: 20px">
                            <strong>{{reason?.fecha}}</strong><br>
                            Tipo: {{reason?.tipo}}<br>
                            Autor: {{reason?.autor}}
                            <div class="text-justify">
                                Motivo: {{reason?.motivo}}
                            </div>
                            </div>
                        </div>
                    </div>
                    <label class="text-muted">Motivo</label>
                    <select class="form-control" [(ngModel)]="motivo.motivo" name="motivo" required>
                        <option value="">Selecciona uno...</option>
                        <option value="BREAK">BREAK</option>
                        <option value="ALMUERZO">ALMUERZO</option>
                        <option value="ADMINISTRATIVO">ADMINISTRATIVO</option>
                        <option value="SERVICIOS">SERVICIOS</option>
                        <option value="FIN_TURNO">FIN DE TURNO</option>
                        <option value="OTROS">OTROS</option>
                    </select>
                    <div style="margin-top: 10px">
                        <label class="text-muted">Descripcion</label>
                        <input type="text" [(ngModel)]="motivo.descripcion" name="descripcion" class="form-control" placeholder="Ingresa un motivo" required>
                    </div>                    
                  </div>
                  <div class="modal-footer">
                      <button *ngIf="agente?.estado.indexOf('PAUSE') === -1 && agente?.modoAgente.indexOf('OUTBOUND') === -1" 
                        [disabled]="agente?.estado.indexOf('OFFLINE') > -1 || f.invalid" 
                        (click)="pausaAgente(f.value, true); f.reset()"
                        type="button" class="btn btn-sm btn-warning" data-dismiss="modal">
                        <i class="fa fa-pause"></i> Pause</button>
                      
                      <button [disabled]="f.invalid" 
                        *ngIf="agente?.estado.indexOf('PAUSE') > -1 && agente?.modoAgente.indexOf('OUTBOUND') === -1" 
                        (click)="pausaAgente(f.value, false); f.reset()"
                        type="button" class="btn btn-sm btn-warning" data-dismiss="modal">
                        <i class="fa fa-play"></i> Unpause</button>

                      <button [disabled]="agente?.estado.indexOf('OFFLINE') > -1" 
                        type="button" class="btn btn-sm btn-primary" (click)="desloguearAgente(f.value); f.reset()"><i class="fa fa-close"></i> Desloguear</button>
                        
                      <button [disabled]="agente?.estado.indexOf('BUSY') === -1 || f.invalid" type="button" class="btn btn-sm btn-danger" (click)="colgarLlamada(f.value); f.reset()">
                          <span class="glyphicon glyphicon-phone-alt"></span>
                      </button>
                  </div>
                </div><!-- /.modal-content -->
            </form>
            </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
    `
})
export class AgenteOPComponent implements OnInit, OnChanges {
    
    motivo: { motivo: string, descripcion: string } = { motivo: '', descripcion: ''};
    @Input() agente: IAgentMonitor;
    @Input('cola') queueName: string
    
    private reason: IAgentStatusReason;
    
    constructor(private $monitor: SocketService, private $agente: AgenteService, private $usuario: UsuarioService) { }

    ngOnInit() { }
    
    ngOnChanges(cambios: IChange) {
        if (!!cambios.agente && !!cambios.agente.currentValue && !!this.agente.estado_idreason) {
            this.$agente.getReason(this.agente.estado_idreason)
                .subscribe(response => {
                    if (response.length > 0) {
                        this.reason = response[0];
                        if (!(this.reason.fecha instanceof Date))
                            this.reason.fecha = moment(this.reason.fecha).format('lll')
                    }
                }, 
                err => console.log(err))
        }
    }
    
    lanzarOps() {
        this.motivo = {
            motivo: '',
            descripcion: ''
        };
        $('#agente-ops').modal();
    }
    
    colgarLlamada(motivo: {motivo: string, descripcion: string}) {
        let idreason = uuid.ObjectID();
        this.$agente.setReason({
                idreason: idreason,
                tipo: motivo.motivo,
                motivo: motivo.descripcion, 
                autor: this.$usuario.usuario.usuario
            })
            .flatMap(() => this.$monitor.enviarComando({
                comando: EComando.HANGUP_CALL,
                data: { 
                    callid: this.agente.channel.UniqueID,
                    channel: (this.agente.agentChannel.Channel || this.agente.channel.Channel),
                    agente: this.agente.idagente,
                    reason: idreason
                }
            }))
            .subscribe(res => console.log(res));
        
        $('#agente-ops').modal('hide');
    }
    
    desloguearAgente(motivo: {motivo: string, descripcion: string}) {
        this.$monitor.enviarComando({
            comando: EComando.AGENT_LOGOUT,
            data: { agente: this.agente.idagente, modoAgente: this.agente.modoAgente }
        }).subscribe(res => console.log(res));
        
        $('#agente-ops').modal('hide');
    }
    
    pausaAgente(motivo: {motivo: string, descripcion: string}, tipo: boolean) {
        let idreason = uuid.ObjectID();
        this.$agente.setReason({
            idreason: idreason,
            tipo: motivo.motivo,
            motivo: motivo.descripcion, 
            autor: this.$usuario.usuario.usuario
        })
        .flatMap(response => {
            if (response.tipo === EDBResponseType.QUERY_OK) {
                let data = { agente: this.agente.idagente, modo: "", modoAgente: this.agente.modoAgente, cola: this.queueName, reason: idreason }        
                if (tipo) // pausa
                    data.modo = "pause";
                else  // unpause
                    data.modo = "unpause";

                return this.$monitor.enviarComando({
                            comando: EComando.AGENT_PAUSE,
                            data: data
                        });
            }
            else {
                let res = new Subject<{ tipo: EResponse, data: Object}>();
                res.next({
                    tipo: EResponse.FALLIDO,
                    data: response.data
                });
                return res.asObservable();
            }
        })
        .subscribe(
            response => {
                console.log(response)
                $('#agente-ops').modal('hide');
            }, err => console.log(err)
        );
    }
} 

interface IChange extends SimpleChanges {
    agente: SimpleChange
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/consola_call/agopciones.component.ts